import { get, post, put, deleted } from '..';
import routes from './routes';

const StockTransferServices = {
  createStockTransfer: async (obj) => {
    const data = await post(routes.createStockTransfer, obj);
    return data;
  },
  getStockTransfers: async (params) => {
    const data = await get(routes.getStockTransfers, params);
    return data;
  },
  getStockTransferById: async (id) => {
    const data = await get(routes.getStockTransferById + id);
    return data;
  },
  updateStockTransfer: async (id, obj) => {
    const data = await put(routes.updateStockTransfer + id, obj);
    return data;
  },
  deleteStockTransfer: async (id) => {
    const data = await deleted(routes.deleteStockTransfer+ id);
    return data;
  }
}

export default StockTransferServices;